import { render, staticRenderFns } from "./ComplianceFailingElementsDrillDown.vue?vue&type=template&id=c36e5d4a&"
import script from "./ComplianceFailingElementsDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceFailingElementsDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports